<template>
  <div class="text-end">
    <FilterTab>
      <template v-slot:body>
        <div class="col-sm-6 col-md-2"></div>
      </template>
      <template v-slot:button2>
        <button class="edit_table_data font_detail" @click="goBack">
          <i class="fas fa-arrow-left"></i
          ><span class="mx-1 bold">Go Back</span>
        </button>
      </template>
      <template v-slot:button1>
        <button
          class="edit_table_data font_detail"
          @click="exportExcel('xlsx')"
        >
          <i class="fas fa-download"></i><span class="mx-1 bold">Export</span>
        </button>
      </template>
    </FilterTab>
  </div>

  <TableCard v-if="$store.getters.getCoachWiseGoodsDetails.length > 0">
    <template v-slot:body>
      <Table id="exportable_data">
        <template v-slot:header>
          <tr>
            <td class="font_detail">SL</td>
            <td class="font_detail">GOODS ID</td>
            <td class="font_detail">Ticket Date Time</td>
            <td class="font_detail">Issued By</td>
            <td class="font_detail">Total Ticket</td>
            <td class="font_detail">Goods Weight</td>
            <td class="font_detail">Passenger Seat</td>
            <td class="font_detail">Total Amount</td>
            <td class="font_detail">Total Payable</td>
          </tr>
        </template>
        <template v-slot:body>
          <tr
            v-for="(item, index) in $store.getters.getCoachWiseGoodsDetails"
            :key="index"
          >
            <td class="font_detail">{{ index + 1 }}</td>
            <td class="font_detail">{{ item?.goodsId }}</td>
            <td class="font_detail">{{ dateFormat(item?.ticketDateTime) }}</td>
            <td class="font_detail">{{ item?.issuedBy?.name }}</td>
            <td class="font_detail">1</td>
            <td class="font_detail">{{ item?.goodsWeight }}</td>
            <td class="font_detail">{{ item?.seatNumberForGoods }}</td>
            <td class="font_detail">{{ item?.totalAmount }} Taka</td>
            <td class="font_detail">{{ item?.payable }} Taka</td>
          </tr>
          <tr class="bg-dark text-white">
            <td class="font_detail"></td>
            <td class="font_detail"></td>
            <td class="font_detail"></td>
            <td class="font_detail"></td>
            <td class="font_detail text-white">
              Total Ticket: {{ totalTicket }}
            </td>
            <td class="font_detail"></td>
            <td class="font_detail"></td>
            <td class="font_detail text-white">
              Total Amount: {{ totalAmount }}
            </td>
            <td class="font_detail text-white">
              Total Paybale: {{ totalPayable }} Taka
            </td>
          </tr>
        </template>
      </Table>
    </template>
  </TableCard>
  <!-- <div class="card h-100 mt-4">
    <div class="card-header text-center bg-white">
      <h5 class="mb-0 text-uppercase">GOODS TICKETS</h5>
    </div>
    <div class="card-body mt-0 py-0">
      
    </div>
  </div> -->
</template>

<script>
import { reactive } from "@vue/reactivity";
import { ref, onBeforeMount } from "vue";
import store from "@/store";
import XLSX from "xlsx";
import moment from "moment";

export default {
  name: "GoodDetails",
  components: {},
  props: {
    coachId: String,
    coachName: String,
    status: Number,
    discount: [Number, String],
    fromDate: String,
    toDate: String,
  },
  emits: ["backToCoachWiseReport"],
  setup(props, { emit }) {
    let coachId = ref(props.coachId);
    let coachNameProps = ref(props.coachName);
    let totalTicket = ref(0);
    let totalAmount = ref(0);
    let totalDiscount = ref(0);
    let totalPayable = ref(0);

    let coachWiseGoodsReport = reactive({
      ticketType: "GOODS",
      coachId: coachId.value,
      fromDate: props.fromDate,
      toDate: props.toDate,
      discount: props.discount,
      status: props.status,
    });

    const options = {
      texts: {
        count: "",
      },
    };

    const dateFormat = (date) => {
      return moment(new Date(String(date)))
        .utcOffset(0, true)
        .format("DD-MMM-yyyy hh:mm A");
    };

    const getDeckDetails = () => {
      //TODO change function name
      store
        .dispatch("getGoodsDetails", coachWiseGoodsReport)
        .then(() => {
          //TODO add loader
          goodDetailsdata();
        })
        .catch((error) => {
          if (error.status === 401) {
            getDeckDetails();
          }
        });
    };

    const goodDetailsdata = () => {
      store.getters.getCoachWiseGoodsDetails.forEach((data) => {
        totalTicket.value = store.getters.getCoachWiseGoodsDetails.length;
        totalAmount.value += data.totalAmount;
        totalDiscount.value += data.discount;
        totalPayable.value += data.payable;
      });
    };

    const goBack = () => {
      emit("backToCoachWiseReport", true);
    };

    const exportExcel = (type, fn, dl) => {
      if (document.getElementById("exportable_data") !== null) {
        var elt = document.getElementById("exportable_data");
        var wb = XLSX.utils.table_to_book(elt, { sheet: "sheet Js" });
        return dl
          ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
          : XLSX.writeFile(
              wb,
              fn || "Admin_CoachWise_Goods_Report." + (type || "xlsx")
            );
      }
    };

    onBeforeMount(() => {
      getDeckDetails();
    });

    return {
      coachWiseGoodsReport,
      totalAmount,
      totalTicket,
      totalDiscount,
      totalPayable,
      goBack,
      exportExcel,
      coachNameProps,
      getDeckDetails,
      options,
      dateFormat,
    };
  },
};
</script>
<style scoped>
h3,
h5 {
  font-size: 36px;
  color: #f04935;
}
h5 {
  font-size: 18px;
}
</style>